(function () {
  function initOffer(section) {
    const offer = section.querySelector('[data-hs-offer]');
    if (!offer || offer.dataset.offerEntrance) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motion.matches || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35)) return;
      offer.dataset.offerEntrance = 'entered';
      observer.disconnect();
    }, { threshold: 0.35 });
    const reduce = () => {
      if (!motion.matches) return;
      observer.disconnect();
      offer.dataset.offerEntrance = 'complete';
    };
    const lastBlock = offer.querySelector('.hs-cat__offer-secondary') || offer.querySelector('.hs-cat__offer-primary');
    const finish = (event) => {
      if (event.animationName === 'hs-cat-offer-enter' && event.target === lastBlock) {
        offer.dataset.offerEntrance = 'complete';
      }
    };
    offer.dataset.offerEntrance = 'pending';
    observer.observe(offer);
    motion.addEventListener('change', reduce);
    offer.addEventListener('animationend', finish);
    section._hsOfferCleanup = () => {
      observer.disconnect();
      motion.removeEventListener('change', reduce);
      offer.removeEventListener('animationend', finish);
      delete offer.dataset.offerEntrance;
    };
  }

  function initSection(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    initOffer(section);

    const grid = section.querySelector('[data-hs-cat-grid]');
    const prev = section.querySelector('[data-hs-cat-prev]');
    const next = section.querySelector('[data-hs-cat-next]');
    if (!grid || !prev || !next) return;

    const cardWidth = () => {
      const first = grid.firstElementChild;
      if (!first) return 0;
      const styles = getComputedStyle(grid);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return first.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = grid.scrollWidth - grid.clientWidth - 1;
      prev.toggleAttribute('disabled', grid.scrollLeft <= 0);
      next.toggleAttribute('disabled', grid.scrollLeft >= maxScroll);
      const noOverflow = grid.scrollWidth <= grid.clientWidth + 2;
      section.querySelector('.hs-cat__nav').style.display = noOverflow ? 'none' : '';
    };

    prev.addEventListener('click', () => {
      grid.scrollBy({ left: -cardWidth() * 2, behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      grid.scrollBy({ left: cardWidth() * 2, behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    section._hsCatCleanup = () => window.removeEventListener('resize', updateButtons);
    updateButtons();
  }

  function init() {
    document.querySelectorAll('[data-hs-cat]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const sec = e.target.querySelector('[data-hs-cat]') || e.target.closest('[data-hs-cat]');
      if (sec) initSection(sec);
    });
    document.addEventListener('shopify:section:unload', (e) => {
      const sec = e.target.querySelector('[data-hs-cat]') || e.target.closest('[data-hs-cat]');
      if (sec && typeof sec._hsCatCleanup === 'function') sec._hsCatCleanup();
      if (sec && typeof sec._hsOfferCleanup === 'function') sec._hsOfferCleanup();
    });
  }
})();
